module.exports = __webpack_public_path__ + "img/benefit-title-tablet.9edeccb7.png";